import useTable from 'logic/Table/useTable'
import TableTitle from './TableTitle'
import TableComponent from './TableComponent'
import DeleteConfirmationModal from '../Modal/DeleteConfirmationModal'
import ErrorModal from '../Modal/ErrorModal'

const DataTable = ({
    itemName,
    useGetQuery,
    useDeleteMutation,
    paginationType,
    visibleKeys,
    allowEdit,
    allowDelete,
    onEdit,
    onCreate,
    translationKey,
    allowAdd,
    allowView,
    onViewItem,
    additionalActions,
    additionalRowActions,
    confirmBeforeDelete,
}) => {
    const {
        tableName,
        tableData,
        totalItems,
        doDelete,
        handleDelete,
        editOrCreateItem,
        duplicateItem,
        columns,
        isLoading,
        page,
        pageSize,
        pagination,
        setPagination,
        setColumnFilters,
        setSorting,
        columnFilters,
        sorting,
        tableSearch,
        setTableSearch,
        columnVisibility,
        setColumnVisibility,
        itemToDeleteId,
        itemToDeleteName,
        closeDeleteConfirmation,
        showErrorModal,
        deleteErrors,
        closeErrorModal,
    } = useTable({
        itemName,
        useGetQuery,
        paginationType,
        useDeleteMutation,
        visibleKeys,
        onEdit,
        onCreate,
        translationKey,
        confirmBeforeDelete,
    })

    return (
        <>
            <TableTitle
                tableName={tableName}
                itemName={itemName}
                handleAddNew={editOrCreateItem}
                allowAdd={allowAdd}
                allowView={allowView}
                additionalActions={additionalActions}
            />

            <TableComponent
                columns={columns}
                data={tableData}
                allowEdit={allowEdit}
                allowDelete={allowDelete}
                allowView={allowView}
                onViewItem={onViewItem}
                editOrCreateItem={editOrCreateItem}
                duplicateItem={duplicateItem}
                totalItems={totalItems}
                isLoading={isLoading}
                paginationType={paginationType}
                pageSize={pageSize}
                page={page}
                pagination={pagination}
                setPagination={setPagination}
                setColumnFilters={setColumnFilters}
                setSorting={setSorting}
                columnFilters={columnFilters}
                sorting={sorting}
                tableSearch={tableSearch}
                setTableSearch={setTableSearch}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                additionalActions={additionalRowActions}
                handleDelete={handleDelete}
            />

            <DeleteConfirmationModal
                idToDelete={itemToDeleteId}
                itemName={itemToDeleteName}
                closeDeleteConfirmation={closeDeleteConfirmation}
                doDelete={doDelete}
            />

            <ErrorModal
                open={showErrorModal}
                onClose={closeErrorModal}
                errors={deleteErrors}
            />
        </>
    )
}

export default DataTable
